import testi from './HelpList.module.scss'
export const HelpList = ({
  title, lista1: { text: listext, href: hreftext }, lista2: { text: listext2, href: hreftext2 }, lista3: { text: listext3, href: hreftext3 }, lista4: { text: listext4, href: hreftext4 },
  lista5: { text: listext5, href: hreftext5 }, lista6: { text: listext6, href: hreftext6 }, lista7: { text: listext7, href: hreftext7 }, lista8: { text: listext8, href: hreftext8 }, lista9: { text: listext9, href: hreftext9 }
}) => {
  return (

    <div className={testi.columnas}>
      <div className={testi.columna}>
        <h1 className={testi.title}>{title}</h1>
        <ul>
          <li><a href={hreftext}><span> {listext} </span></a></li>
          <li><a href={hreftext2}><span> {listext2} </span></a></li>
          <li><a href={hreftext3}><span> {listext3} </span></a></li>
          <li><a href={hreftext4}><span> {listext4} </span></a></li>
          <li><a href={hreftext5}><span> {listext5} </span></a></li>
          <li><a href={hreftext6}><span> {listext6} </span></a></li>
          <li><a href={hreftext7}><span> {listext7} </span></a></li>
          <li><a href={hreftext8}><span> {listext8} </span></a></li>
          <li><a href={hreftext9}><span> {listext9} </span></a></li>

        </ul>
      </div>
    </div>
  )
}
